import useApiConfig from './useApiConfig';
import { selectCanUseLoyalty } from '../reducers/offerOptions';
import { useAppSelector } from '../utils';
import { useGetOffersQuery, useGetOffersWithLoyaltyQuery } from '../apis/hondaRestApi';
import { LOYALTY_OFFER_TYPES_SET } from '../../components/PaymentCalculator/ViewOffers/constants';
export const useFetchOffers = ({ transmissionIds, currentTransmissionId, paymentMethod, shouldSkip = false, }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const apiConfig = useApiConfig();
    const canUseLoyalty = useAppSelector(selectCanUseLoyalty);
    const validTransmissionIds = transmissionIds.filter(Boolean);
    const transmissionId = currentTransmissionId || validTransmissionIds[0];
    const isApiConfigInvalid = Object.values(apiConfig).some(val => !val);
    const canSkipAll = shouldSkip || isApiConfigInvalid || !validTransmissionIds.length;
    const { data, isFetching, isLoading, isSuccess, error } = useGetOffersQuery({
        ...apiConfig,
        transmissionIds: validTransmissionIds.join(';'),
    }, { skip: canSkipAll });
    const { data: loyaltyData } = useGetOffersWithLoyaltyQuery({
        ...apiConfig,
        transmissionIds: validTransmissionIds.join(';'),
    }, { skip: canSkipAll || !canUseLoyalty });
    const loyaltyOffers = ((_d = (_c = (_b = (_a = loyaltyData === null || loyaltyData === void 0 ? void 0 : loyaltyData.find) === null || _a === void 0 ? void 0 : _a.call(loyaltyData, i => transmissionId && i.transmissionKey === transmissionId)) === null || _b === void 0 ? void 0 : _b.loyaltyOffers) === null || _c === void 0 ? void 0 : _c[paymentMethod]) !== null && _d !== void 0 ? _d : []).filter(item => LOYALTY_OFFER_TYPES_SET.has(item === null || item === void 0 ? void 0 : item.type));
    const incentiveOffers = (_h = (_g = (_f = (_e = data === null || data === void 0 ? void 0 : data.find) === null || _e === void 0 ? void 0 : _e.call(data, i => transmissionId && i.transmissionKey === transmissionId)) === null || _f === void 0 ? void 0 : _f.incentiveOffers) === null || _g === void 0 ? void 0 : _g[paymentMethod]) !== null && _h !== void 0 ? _h : [];
    return {
        loyaltyOffers,
        incentiveOffers,
        isFetching,
        isLoading,
        isSuccess,
        error,
    };
};
export default useFetchOffers;
